<template>
  <div class="read-only pt-0 user-read-only">

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Phone
      </label>
      <span v-if="user.phone">
        {{ user.phone }}
      </span>
      <span v-else>
        &mdash;
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Alert Lists
      </label>
      <div
        class="tag-input"
        v-if="alertLists.length > 0"
      >
        <div class="tag-input__list">
          <div
            v-for="list in alertLists"
            :key="list.id"
            class="tag-input__list__item"
          >
            <span>{{ list.name }}</span>
          </div>
        </div>
      </div>
      <span v-else>
        &mdash;
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Subscriptions
      </label>

      <div
        class="tag-input"
        v-if="user.all_subscriptions.length > 0"
      >
        <div class="tag-input__list">
          <router-link
            v-for="sub in user.all_subscriptions"
            :key="sub.id"
            :to="`/subscriptions/${sub.id}`"
            class="tag-input__list__item link"
          >
            <span>{{ sub.name }}</span>
          </router-link>
        </div>
      </div>
      <span v-else>
        &mdash;
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        GDPR
      </label>
      <span
        :class="`${user.is_gdpr_compliant ? 'text-success' : 'text-danger'}`"
      >
        {{ user.is_gdpr_compliant ? 'Compliant' : 'Not Compliant' }}
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Interests
      </label>
      <span v-if="user.interests">
        {{ user.interests }}
      </span>
      <span v-else>
        &mdash;
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Account
      </label>
      <router-link
        v-if="user.account"
        :to="{ name: 'accounts.view', params: { accountId: user.account_id } }"
      >
        {{ user.account.name }}
      </router-link>
      <span v-else>
        &mdash;
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Channel
      </label>
      <router-link
        v-if="user.channel"
        :to="{ name: 'channels.view', params: { channelId: user.channel_id } }"
      >
        {{ user.channel.name }}
      </router-link>
      <span v-else>
        &mdash;
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    alertLists: {
      type: Array,
      required: true,
    },
  },
}
</script>

